module.exports = __webpack_public_path__ + "static/media/maestro-image.cd69a4a1.png";